import { Helmet } from 'react-helmet-async';
import { useLocation } from 'react-router-dom';

export function GlobalSEO() {
  const location = useLocation();
  const canonicalUrl = `https://baklight.com${location.pathname}`;
  const organizationSchema = {
    "@context": "https://schema.org",
    "@type": ["Organization", "ProductionCompany"],
    "@id": "https://baklight.com/#organization",
    "name": "Baklight",
    "legalName": "Baklight Films",
    "url": "https://baklight.com",
    "logo": "https://baklight.com/assets/logo.png",
    "description": "Award-winning film production company in Guadalajara, Mexico. Full-service production for commercials, documentaries, and narrative films with international crews and local expertise.",
    "foundingDate": "2010",
    "email": "paco@baklight.com",
    "telephone": "+52-33-3808-3824",
    "address": {
      "@type": "PostalAddress",
      "addressLocality": "Guadalajara",
      "addressRegion": "Jalisco",
      "addressCountry": "MX"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "20.6597",
      "longitude": "-103.3496"
    },
    "areaServed": [
      {
        "@type": "Country",
        "name": "Mexico"
      },
      {
        "@type": "Country",
        "name": "United States"
      },
      {
        "@type": "Country",
        "name": "Canada"
      }
    ],
    "sameAs": [
      "https://www.instagram.com/baklight",
      "https://www.linkedin.com/company/baklight",
      "https://vimeo.com/baklight"
    ],
    "founder": {
      "@type": "Person",
      "name": "Paco Herrera",
      "jobTitle": "Director & Cinematographer",
      "description": "Mexican director and cinematographer whose work explores identity, place and human connection through cinematic storytelling"
    },
    "makesOffer": [
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Commercial Production",
          "description": "Full-service commercial production with international crews and local expertise"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Documentary Production",
          "description": "Documentary filmmaking services across Mexico with bilingual crews"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Narrative Film Production",
          "description": "Feature film and narrative production services in Mexico"
        }
      },
      {
        "@type": "Offer",
        "itemOffered": {
          "@type": "Service",
          "name": "Location Services Mexico",
          "description": "Location scouting, permits, and production coordination across Mexico"
        }
      }
    ],
    "knowsAbout": [
      "Film Production",
      "Cinematography",
      "Documentary Filmmaking",
      "Commercial Production",
      "Location Services",
      "Mexico Film Incentives",
      "EFICINE Tax Credit",
      "Film Permits Mexico",
      "International Co-Productions"
    ]
  };

  const websiteSchema = {
    "@context": "https://schema.org",
    "@type": "WebSite",
    "@id": "https://baklight.com/#website",
    "url": "https://baklight.com",
    "name": "Baklight Films",
    "description": "Award-winning film production company in Guadalajara, Mexico",
    "publisher": {
      "@id": "https://baklight.com/#organization"
    },
    "potentialAction": {
      "@type": "SearchAction",
      "target": {
        "@type": "EntryPoint",
        "urlTemplate": "https://baklight.com/work?search={search_term_string}"
      },
      "query-input": "required name=search_term_string"
    }
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    "itemListElement": [
      {
        "@type": "ListItem",
        "position": 1,
        "name": "Home",
        "item": "https://baklight.com/"
      }
    ]
  };

  return (
    <Helmet>
      {/* Canonical Tag */}
      <link rel="canonical" href={canonicalUrl} />
      
      {/* Organization Schema */}
      <script type="application/ld+json">
        {JSON.stringify(organizationSchema)}
      </script>

      {/* Website Schema */}
      <script type="application/ld+json">
        {JSON.stringify(websiteSchema)}
      </script>

      {/* Breadcrumb Schema */}
      <script type="application/ld+json">
        {JSON.stringify(breadcrumbSchema)}
      </script>

      {/* Global Meta Tags */}
      <meta name="author" content="Baklight Films" />
      <meta name="copyright" content="© 2026 Baklight Films. All rights reserved." />
      <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
      <meta name="googlebot" content="index, follow" />
      
      {/* Geographic Tags */}
      <meta name="geo.region" content="MX-JAL" />
      <meta name="geo.placename" content="Guadalajara" />
      <meta name="geo.position" content="20.6597;-103.3496" />
      <meta name="ICBM" content="20.6597, -103.3496" />
      
      {/* Language */}
      <link rel="alternate" hrefLang="en" href="https://baklight.com" />
      <link rel="alternate" hrefLang="x-default" href="https://baklight.com" />
    </Helmet>
  );
}
